// Единый справочник всех значений `command` для WMS API.
//
// Все запросы в src/api/*.js идут на один и тот же путь ('') с
// параметром ?command=... (см. api.js) — это RPC-стиль, а не REST.
// Чтобы не плодить дубли/опечатки в строковых литералах, разбросанные
// по файлам, все команды объявлены здесь один раз.
//
// Важно: совпадение команды у двух разных операций — не всегда ошибка.
// WMS может различать их по телу запроса, а не по имени команды
// (см. комментарии ниже, где это так).

export const API_COMMANDS = {
  // --- Заявки на приём (ASN) ---
  // Используется и для создания, и для отмены ASN — WMS различает
  // операцию по содержимому тела запроса, не по имени команды.
  ASN_CREATE_OR_CANCEL: 'asn',
  ASN_LIST: 'asns',

  // --- Заказы ---
  ORDER_CREATE: 'order',
  ORDER_LIST: 'orders',

  // --- Файлы/вложения ---
  FILE_DELETE: 'delete_file',
  FILE_EDIT_COPIES: 'edit_copies_file',
  FILE_ADD_TO_ORDER: 'add_file_to_order',

  // --- Платежи и баланс ---
  PAYMENT_METHODS: 'payment_methods',
  OWNER_BALANCE: 'owner_balance',
  AVAILABLE_DATES: 'available_dates',
  PAYMENT_BILL: 'make_payment_bill',
  PAYMENT_SBP: 'make_payment_sbp',
  PAYMENT_TRANSACTIONS: 'bank_transactions',
  PAYMENT_CHOOSE_DEFAULT: 'choose_default_payment',
  PAYMENT_PAY_ALL_SERVICES: 'pay_all_services',
  PAYMENT_DELETE: 'delete_payment',
  PAYMENT_MAKE: 'make_payment',
  HAVE_DEBIT: 'havedebit',

  // --- Пользователь ---
  USER_DELETE: 'delete_user',
  USER_INFO: 'userinfo',
  USER_INFO_UPDATE: 'userinfo_update',

  // --- Адреса ---
  ADDRESS_ADD: 'address_add',
  ADDRESS_DELETE: 'address_del',
  ADDRESS_LIST: 'addresses',

  // --- Авторизация / регистрация ---
  AUTH_REQUEST_CODE: 'code_auth',
  // "confirmt" вместо "confirm" — похоже на опечатку, но это реальное
  // имя команды в контракте WMS. Менять самостоятельно нельзя, пока
  // это не согласовано и не исправлено на стороне бэкенда одновременно.
  AUTH_CONFIRM_CODE: 'confirmt_code_auth',
  AUTH_LOGOUT: 'logout',
  // Используется и для регистрации физлиц, и для юрлиц — WMS
  // различает по составу полей в теле запроса.
  REGISTRATION: 'registration',

  // --- Склад ---
  STOCKS_LIST: 'stocks',
  DELIVERY_COST: 'delivery_cost',
  GRM_COMMENT: 'grm_comment',

  // --- Обращения в поддержку ---
  SEND_QUESTION: 'make_question',
};
